var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.99994C11.1046 8.99994 12 8.10455 12 6.99997C12 5.89539 11.1046 5 10 5C8.8954 5 8 5.89539 8 6.99997C8 8.10455 8.8954 8.99994 10 8.99994Z",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.99991C17.1114 9.99086 13.7183 12.9998 10 12.9998C6.2817 12.9998 2.88856 9.99086 1 6.99991C3.29855 4.1582 5.99163 1 10 1C14.0084 1 16.7015 4.15815 19 6.99991Z",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon_eye.d96ef2e56505c0eca150b0e191df9b45.svg";
export { ForwardRef as ReactComponent };